import DOMPurify from 'dompurify';
import type { Config } from 'dompurify';

const CONFIG: Config = {
  ALLOWED_TAGS: ['p', 'br', 'b', 'i', 'em', 'strong', 'u', 'ul', 'ol', 'li', 'span', 'div', 'font', 'h2'],
  ALLOWED_ATTR: ['style', 'class', 'color', 'size', 'face'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'link', 'style', 'img', 'svg', 'math', 'form', 'a'],
  FORBID_ATTR: ['src', 'srcset', 'href', 'xlink:href'],
  RETURN_TRUSTED_TYPE: false,
};

export function sanitizeHtml(dirty: string): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, CONFIG);
}

export function isBlankNoteHtml(value: string): boolean {
  if (!value) return true;
  return value.replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim() === '';
}

export function htmlMapHasContent(map?: Record<string, string> | null): boolean {
  if (!map) return false;
  return Object.values(map).some((value) => !isBlankNoteHtml(value));
}

export function notePlainLength(value: string): number {
  if (!value) return 0;
  return value.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').length;
}
